(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 9212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(1473);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var TextGradient = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _overrideClassName = param.overrideClassName, overrideClassName = _overrideClassName === void 0 ? "" : _overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            backgroundImage: light ? "linear-gradient(to right, #86EFAC, #67E8F9)" : "linear-gradient(to right, #06B6D4, #22C55E)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent"
        },
        className: "".concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextGradient);


/***/ }),

/***/ 1473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _app_components_gradient_gradient_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3725);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _app_components_gradient_gradient_container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9467);




var AboutPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "pb-10",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-8 py-12 md:p-12 lg:p-24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid grid-cols-12 max-w-[1440px] mx-auto md:gap-x-10 lg:gap-x-16 xl:gap-x-24",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-span-12 md:col-span-6 xl:col-span-6 flex flex-col justify-center items-end gap-y-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col gap-y-4 text-left w-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_gradient_gradient_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        overrideClassName: "mobile-h2 md:h3 xl:h2 2xl:h1 py-2",
                                        children: "A new kind of waste management company"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-body-xl text-text-color-mid-em",
                                        children: "\u2014 We\u2019ve formed a powerful ecosystem that empowers and connects key industry stakeholders using technological innovation."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-span-12 md:col-span-6 xl:col-span-6 flex items-center justify-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-4/5 pt-10 md:pt-0 md:w-full",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    className: "rounded-lg",
                                    src: "/images/about/lady.png",
                                    alt: "Waste Management",
                                    width: 560,
                                    height: 599
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-background-low-em py-8 px-10 md:py-16 lg:px-20 text-center space-y-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-secondary-dark text-body-xl-medium",
                        children: "About us"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "h4 lg:h2 text-background-primary-dark",
                        children: "About Simplewaste"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_gradient_gradient_container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            overrideClassName: "w-[200px] h-2"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-text-color-mid-em text-body-sm md:text-body-md lg:text-body-xl",
                        children: "Learn more about the company and the team behind it."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-start pt-8 space-y-4 lg:space-y-10 flex flex-col xl:items-center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "space-y-1 xl:w-[1120px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-secondary-dark text-body-xl-medium",
                                        children: "Who we are"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "h5 text-text-color-high-em",
                                        children: "Waste Management Company"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "space-y-4 lg:space-y-0 lg:flex lg:items-start lg:justify-center lg:space-x-16 ",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-text-color-mid-em text-body-md lg:subheading lg:w-[494px]",
                                        children: "At SimpleWaste we\u2019ve combined the best aspects of technology, expertise, and support to create an unmatched user experience."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-20 h-1 bg-text-color-disabled lg:w-1 lg:h-20"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-text-color-mid-em text-body-md lg:subheading lg:w-[494px]",
                                        children: "Our goal is to transform outdated infrastructure, with its inefficient methods of operation, and to deliver waste and recycling services as they should be delivered, with proficient simplicity."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "pb-6 sm:p-10 lg:py-16 lg:px-20 xl:px-32 xl-2:!px-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "lg:bg-background-primary-dark-dark lg:rounded-2xl lg:relative",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center bg-cover bg-center justify-end sm:rounded-2xl sm:shadow-lg lg:bg-right lg:rounded-r-none w-full lg:h-[864px] lg:w-[640px] 3xl:!w-1/2",
                        style: {
                            backgroundImage: "url('/images/about/building.jpeg')"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "bg-white p-6 my-10 lg:my-0 xs:rounded-lg xs:w-2/3 md:w-3/5 lg:w-[515px] xl:w-[624px] lg:p-8 lg:absolute lg:right-36 2xl:right-1/4 3xl:right-1/3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "space-y-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "h5 sm:h4 lg:h3 text-text-color-high-em",
                                        children: "Our Company"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_gradient_gradient_container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    overrideClassName: "w-[150px] h-2 mt-6"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "pt-6 space-y-6 text-text-color-high-em text-body-md sm:text-body-xl",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "SimpleWaste is a national Waste & Recycling Management Company providing specialized technology and service to all commercial and residential sectors."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Our management platform provides a user interface that combines dynamic purchasing automation, intuitive functionality, and ease-of-use. This powerful combination delivers maximum value and unmatched user experience."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Our technology innovation provides a distinct industry advantage to customers, vendors, and partners."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Companies that utilizes our platform benefit through data-driven insights, performance optimization, cost control, and cost reduction."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sm:pt-10 sm:px-10 lg:pt-0 lg:pb-10 lg:px-20 xl:px-32 xl-2:!px-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "lg:bg-background-low-em lg:rounded-2xl lg:flex lg:justify-end lg:relative",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center bg-cover bg-center sm:rounded-2xl sm:shadow-lg lg:rounded-l-none w-full lg:h-[864px] lg:w-[640px] 3xl:!w-1/2",
                        style: {
                            backgroundImage: "url('/images/about/mountain.jpeg')"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "bg-white my-10 lg:my-0 w-full p-6 xs:rounded-lg xs:w-2/3 md:w-3/5 lg:w-[515px] xl:w-[624px] lg:p-8 lg:absolute lg:left-10 xl:left-36 2xl:left-64 3xl:left-1/3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "space-y-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "h5 sm:h4 lg:h3 text-text-color-high-em",
                                        children: "Our Outlook"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_gradient_gradient_container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    overrideClassName: "w-[150px] h-2 mt-6"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "pt-6 space-y-6 text-text-color-high-em text-body-md sm:text-body-xl",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "At SimpleWaste we\u2019re elevating the future of waste management through innovation. Our platform and service suite is designed to provide an unmatched SaaS experience that\u2019s both dynamic and simplistic."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Our business model offers a perfect blend of technology, industry representation, direct savings, and customer support. At the end of the day, our goals are achieved through our principal drive for excellence."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "We continue to update our user\u2019s experience through technological advancement and industry alignment."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "We\u2019re increasing value-added services through persistent growth, market-share, and subsidiary expansion."
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AboutPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);